// import React, { useState, useEffect, useMemo } from 'react';
// import { useNavigate } from "react-router-dom";
// import { Modal, Button, Form } from "react-bootstrap";
// import axios from "axios";
// import Select from 'react-select';
// import makeAnimated from 'react-select/animated';
// import config from '../../Common/Configurations/APIConfig';

// // Define available specializations (you can fetch these from API if needed)
// const AVAILABLE_SPECIALIZATIONS = [
//     { value: 'Haircut', label: 'Haircut' },
//     { value: 'Hair Coloring', label: 'Hair Coloring' },
//     { value: 'Hair Styling', label: 'Hair Styling' },
//     { value: 'Hair Treatment', label: 'Hair Treatment' },
//     { value: 'Manicure', label: 'Manicure' },
//     { value: 'Pedicure', label: 'Pedicure' },
//     { value: 'Facial', label: 'Facial' },
//     { value: 'Waxing', label: 'Waxing' },
//     { value: 'Massage', label: 'Massage' },
//     { value: 'Makeup', label: 'Makeup' },
//     { value: 'Skincare', label: 'Skincare' },
//     { value: 'Nail Art', label: 'Nail Art' },
//     { value: 'Eyebrow Shaping', label: 'Eyebrow Shaping' },
//     { value: 'Hair Extension', label: 'Hair Extension' },
//     { value: 'Bridal Services', label: 'Bridal Services' }
// ];

// const animatedComponents = makeAnimated();

// const initialFieldValues = {
//     staffId: '00000000-0000-0000-0000-000000000000',
//     salonId: '',
//     name: '',
//     specializations: '', // Will store as comma-separated string
//     isActive: true
// };

// const SalonStaff = () => {
//     // API & Data State
//     const [lists, setLists] = useState([]);
//     const [btnLoading, setBtnLoading] = useState(false);
//     const [totalPages, setTotalPages] = useState(0);
//     const [pageSize, setPageSize] = useState(10);
//     const [pageNumber, setPageNumber] = useState(1);
//     const [totalRecords, setTotalRecords] = useState(0);

//     // Form & UI State
//     const [showModal, setShowModal] = useState(false);
//     const [values, setValues] = useState(initialFieldValues);
//     const [selectedSpecializations, setSelectedSpecializations] = useState([]);
//     const [errors, setErrors] = useState({});
//     const [showDeleteModal, setShowDeleteModal] = useState(false);
//     const [itemToDelete, setItemToDelete] = useState(null);

//     const THEME_COLOR = '#065f46';
    
//     // Get salonId from localStorage
//     const loggedInSalonId = localStorage.getItem('salonId');

//     // --- Helper Functions ---
    
//     // Convert comma-separated string to array of options
//     const parseSpecializations = (specializationsString) => {
//         if (!specializationsString) return [];
//         return specializationsString.split(',')
//             .map(spec => spec.trim())
//             .filter(spec => spec)
//             .map(spec => ({ value: spec, label: spec }));
//     };

//     // Convert selected options back to comma-separated string
//     const formatSpecializations = (selectedOptions) => {
//         return selectedOptions.map(option => option.value).join(',');
//     };

//     // Parse specializations for display
//     const formatSpecializationsForDisplay = (specializationsString) => {
//         if (!specializationsString) return 'None';
//         const specs = specializationsString.split(',').map(s => s.trim());
//         return specs.map((spec, index) => (
//             <span key={index} className="badge bg-light text-dark me-1 mb-1">
//                 {spec}
//             </span>
//         ));
//     };

//     // --- API CALLS ---

//     // 1. Get Staff List - only for current salon
//     const GetData = async (pNum) => {
//         try {
//             // Check if salonId exists
//             if (!loggedInSalonId) {
//                 console.error("No salonId found in localStorage. User might not be logged in.");
//                 return;
//             }

//           const res = await axios.get(
//   `${config.APIACTIVEURL}${config.GETSTAFFBYSALONID}/${loggedInSalonId}`
// );

//             if (res.data) {
//                 const result = Array.isArray(res.data) ? res.data : res.data.data;
//                 setLists(result || []);
//                 setTotalPages(res.data.totalPages || 0);
//                 setTotalRecords(res.data.totalRecords || 0);
//                 setPageNumber(res.data.pageNumber || 1);
//             }
//         } catch (error) {
//             console.error("Error fetching staff", error);
//         }
//     };

//     useEffect(() => {
//         // Check if user is logged in and has salonId
//         if (loggedInSalonId) {
//             GetData(pageNumber);
            
//             // Set the salonId in initial values for new staff
//             setValues(prevValues => ({
//                 ...prevValues,
//                 salonId: loggedInSalonId
//             }));
//         } else {
//             console.error("No salonId found. Please login again.");
//             // You might want to redirect to login page here
//         }
//     }, [pageNumber]);

//     // --- HANDLERS ---

//     const handleInput = (e) => {
//         const { name, value, type, checked } = e.target;
//         setValues({ 
//             ...values, 
//             [name]: type === 'checkbox' ? checked : value 
//         });
//     };

//     const handleSpecializationsChange = (selectedOptions) => {
//         setSelectedSpecializations(selectedOptions || []);
//         // Update the values object with comma-separated string
//         setValues({
//             ...values,
//             specializations: formatSpecializations(selectedOptions || [])
//         });
//     };

//     const validate = () => {
//         let temp = {};
//         temp.name = values.name ? "" : "Staff Name is required";
//         temp.salonId = values.salonId ? "" : "Salon not assigned. Please login again.";
//         setErrors(temp);
//         return Object.values(temp).every(x => x === "");
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (validate()) {
//             setBtnLoading(true);
//             try {
//                 const isNew = values.staffId === "00000000-0000-0000-0000-000000000000";
                
//                 // Prepare data for API - always use the logged-in salonId
//                 const staffData = {
//                     ...values,
//                     salonId: loggedInSalonId // Ensure we always use the logged-in salon
//                 };

//                 if (isNew) {
//                     await axios.post(config.APIACTIVEURL + config.CREATESTAFF, staffData);
//                 } else {
//                     await axios.put(config.APIACTIVEURL + config.UPDATESTAFF, staffData);
//                 }

//                 setShowModal(false);
//                 resetForm();
//                 GetData(pageNumber);
//             } catch (error) {
//                 console.error("Save failed", error);
//                 alert(error.response?.data?.message || "Error saving staff");
//             } finally {
//                 setBtnLoading(false);
//             }
//         }
//     };

//     const handleDelete = async () => {
//         if (itemToDelete) {
//             try {
//                 await axios.delete(`${config.APIACTIVEURL}${config.DELETESTAFF}/${itemToDelete}`);
//                 setShowDeleteModal(false);
//                 GetData(pageNumber);
//             } catch (error) {
//                 console.error("Delete failed", error);
//             }
//         }
//     };

//     const handleEdit = (staff) => {
//         setValues(staff);
//         // Parse specializations when editing
//         setSelectedSpecializations(parseSpecializations(staff.specializations));
//         setShowModal(true);
//     };

//     const resetForm = () => {
//         // Reset to initial values but preserve the salonId
//         setValues({
//             ...initialFieldValues,
//             salonId: loggedInSalonId // Keep the logged-in salonId
//         });
//         setSelectedSpecializations([]);
//         setErrors({});
//     };

//     // Custom styles for react-select
//     const customSelectStyles = {
//         control: (base, state) => ({
//             ...base,
//             borderColor: errors.specializations ? '#dc3545' : '#dee2e6',
//             borderRadius: '0.375rem',
//             boxShadow: state.isFocused ? `0 0 0 0.25rem rgba(6, 95, 70, 0.25)` : 'none',
//             '&:hover': {
//                 borderColor: '#ced4da'
//             },
//             minHeight: '38px'
//         }),
//         multiValue: (base) => ({
//             ...base,
//             backgroundColor: THEME_COLOR,
//             color: 'white',
//         }),
//         multiValueLabel: (base) => ({
//             ...base,
//             color: 'white',
//         }),
//         multiValueRemove: (base) => ({
//             ...base,
//             color: 'white',
//             ':hover': {
//                 backgroundColor: '#064e3b',
//                 color: 'white',
//             },
//         }),
//     };

//     return (
//         <div className="page-content" style={{ paddingTop: "80px" }}>
//             <div className="container-fluid py-4">
//                 <div className="card border-0 shadow-sm rounded-4">
//                     <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
//                         <h4 className="fw-bold mb-0" style={{ color: '#064e3b' }}>Staff Master</h4>
//                         <button className="btn text-white fw-bold px-4 shadow-sm"
//                             style={{ backgroundColor: THEME_COLOR }}
//                             onClick={() => { resetForm(); setShowModal(true); }}>
//                             <i className="ri-add-line me-1"></i> Add New Staff
//                         </button>
//                     </div>

//                     <div className="card-body">
//                         <div className="table-responsive">
//                             <table className="table table-hover align-middle">
//                                 <thead className="table-light">
//                                     <tr className="text-secondary small text-uppercase">
//                                         <th>Staff Name</th>
//                                         <th>Specializations</th>
//                                         <th>Status</th>
//                                         <th className="text-center">Actions</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {lists.map((item) => (
//                                         <tr key={item.staffId}>
//                                             <td className="fw-bold text-dark">{item.name}</td>
//                                             <td>
//                                                 <div className="d-flex flex-wrap">
//                                                     {formatSpecializationsForDisplay(item.specializations)}
//                                                 </div>
//                                             </td>
//                                             <td>
//                                                 <span className={`badge rounded-pill ${item.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
//                                                     {item.isActive ? 'Active' : 'Inactive'}
//                                                 </span>
//                                             </td>
//                                             <td className="text-center">
//                                                 <button className="btn btn-sm btn-outline-primary border-0 me-2" onClick={() => handleEdit(item)}>
//                                                     <i className="ri-pencil-line fs-5"></i>
//                                                 </button>
//                                                 <button className="btn btn-sm btn-outline-danger border-0"
//                                                     onClick={() => { setItemToDelete(item.staffId); setShowDeleteModal(true); }}>
//                                                     <i className="ri-delete-bin-line fs-5"></i>
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>

//                 {/* FORM MODAL */}
//                 <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
//                     <Modal.Header closeButton className="border-0">
//                         <Modal.Title className="fw-bold">
//                             {values.staffId === "00000000-0000-0000-0000-000000000000"
//                                 ? 'Register New Staff'
//                                 : 'Edit Staff Details'}
//                         </Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body className="px-4">
//                         <form className="row g-3" onSubmit={handleSubmit}>
//                             <div className="col-md-12">
//                                 <label className="form-label small fw-bold text-muted">Staff Name *</label>
//                                 <input 
//                                     type="text" 
//                                     name="name" 
//                                     value={values.name} 
//                                     onChange={handleInput} 
//                                     className={`form-control ${errors.name ? 'is-invalid' : ''}`} 
//                                     placeholder="Enter staff name"
//                                 />
//                                 {errors.name && <div className="invalid-feedback">{errors.name}</div>}
//                             </div>

//                             <div className="col-12">
//                                 <label className="form-label small fw-bold text-muted">Specializations</label>
//                                 <Select
//                                     isMulti
//                                     name="specializations"
//                                     options={AVAILABLE_SPECIALIZATIONS}
//                                     className={`basic-multi-select ${errors.specializations ? 'is-invalid' : ''}`}
//                                     classNamePrefix="select"
//                                     value={selectedSpecializations}
//                                     onChange={handleSpecializationsChange}
//                                     components={animatedComponents}
//                                     styles={customSelectStyles}
//                                     placeholder="Select specializations..."
//                                     isSearchable={true}
//                                     isClearable={true}
//                                 />
//                                 <div className="form-text">
//                                     Select one or multiple specializations. Use search to find specific skills.
//                                 </div>
//                             </div>

//                             <div className="col-md-6">
//                                 <div className="form-check form-switch mt-3">
//                                     <input 
//                                         className="form-check-input" 
//                                         type="checkbox" 
//                                         name="isActive" 
//                                         checked={values.isActive} 
//                                         onChange={handleInput} 
//                                         id="isActiveSwitch" 
//                                     />
//                                     <label className="form-check-label fw-bold text-dark" htmlFor="isActiveSwitch">
//                                         Active Status
//                                     </label>
//                                 </div>
//                             </div>

//                             <div className="modal-footer border-0 p-0 mt-4">
//                                 <button type="button" className="btn btn-light px-4 fw-bold" onClick={() => setShowModal(false)}>
//                                     Cancel
//                                 </button>
//                                 <button 
//                                     type="submit" 
//                                     disabled={btnLoading} 
//                                     className="btn text-white px-5 fw-bold shadow-sm" 
//                                     style={{ backgroundColor: THEME_COLOR }}
//                                 >
//                                     {btnLoading ? (
//                                         <>
//                                             <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                             Processing...
//                                         </>
//                                     ) : (
//                                         'Save Staff'
//                                     )}
//                                 </button>
//                             </div>
//                         </form>
//                     </Modal.Body>
//                 </Modal>

//                 {/* DELETE MODAL */}
//                 <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
//                     <Modal.Header closeButton>
//                         <Modal.Title>Confirm Delete</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>Are you sure you want to delete this staff member? This action cannot be undone.</Modal.Body>
//                     <Modal.Footer>
//                         <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
//                         <Button variant="danger" onClick={handleDelete}>Delete Permanently</Button>
//                     </Modal.Footer>
//                 </Modal>
//             </div>
//         </div>
//     );
// };

// export default SalonStaff;

//web view 

import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import config from '../../Common/Configurations/APIConfig';

const AVAILABLE_SPECIALIZATIONS = [
    { value: 'Haircut', label: 'Haircut' },
    { value: 'Hair Coloring', label: 'Hair Coloring' },
    { value: 'Hair Styling', label: 'Hair Styling' },
    { value: 'Hair Treatment', label: 'Hair Treatment' },
    { value: 'Manicure', label: 'Manicure' },
    { value: 'Pedicure', label: 'Pedicure' },
    { value: 'Facial', label: 'Facial' },
    { value: 'Waxing', label: 'Waxing' },
    { value: 'Massage', label: 'Massage' },
    { value: 'Makeup', label: 'Makeup' },
    { value: 'Skincare', label: 'Skincare' },
    { value: 'Nail Art', label: 'Nail Art' },
    { value: 'Eyebrow Shaping', label: 'Eyebrow Shaping' },
    { value: 'Hair Extension', label: 'Hair Extension' },
    { value: 'Bridal Services', label: 'Bridal Services' }
];

const animatedComponents = makeAnimated();

const initialFieldValues = {
    staffId: '00000000-0000-0000-0000-000000000000',
    salonId: '',
    name: '',
    specializations: '', 
    isActive: true
};

const SalonStaff = () => {
    const [lists, setLists] = useState([]);
    const [btnLoading, setBtnLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const [values, setValues] = useState(initialFieldValues);
    const [selectedSpecializations, setSelectedSpecializations] = useState([]);
    const [errors, setErrors] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const THEME_COLOR = '#065f46';
    const loggedInSalonId = localStorage.getItem('salonId');

    const parseSpecializations = (specializationsString) => {
        if (!specializationsString) return [];
        return specializationsString.split(',')
            .map(spec => spec.trim())
            .filter(spec => spec)
            .map(spec => ({ value: spec, label: spec }));
    };

    const formatSpecializations = (selectedOptions) => {
        return selectedOptions.map(option => option.value).join(',');
    };

    const formatSpecializationsForDisplay = (specializationsString) => {
        if (!specializationsString) return <span className="text-muted small">None</span>;
        const specs = specializationsString.split(',').map(s => s.trim());
        return specs.map((spec, index) => (
            <span key={index} className="badge bg-light text-dark border me-1 mb-1" style={{ fontSize: '0.7rem' }}>
                {spec}
            </span>
        ));
    };

    const GetData = async (pNum) => {
        try {
            if (!loggedInSalonId) return;
            const res = await axios.get(`${config.APIACTIVEURL}${config.GETSTAFFBYSALONID}/${loggedInSalonId}`);
            if (res.data) {
                const result = Array.isArray(res.data) ? res.data : res.data.data;
                setLists(result || []);
                setTotalPages(res.data.totalPages || 0);
                setTotalRecords(res.data.totalRecords || 0);
                setPageNumber(res.data.pageNumber || 1);
            }
        } catch (error) { console.error("Error fetching staff", error); }
    };

    useEffect(() => {
        if (loggedInSalonId) {
            GetData(pageNumber);
            setValues(prevValues => ({ ...prevValues, salonId: loggedInSalonId }));
        }
    }, [pageNumber]);

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        setValues({ ...values, [name]: type === 'checkbox' ? checked : value });
    };

    const handleSpecializationsChange = (selectedOptions) => {
        setSelectedSpecializations(selectedOptions || []);
        setValues({ ...values, specializations: formatSpecializations(selectedOptions || []) });
    };

    const validate = () => {
        let temp = {};
        temp.name = values.name ? "" : "Staff Name is required";
        temp.salonId = values.salonId ? "" : "Salon not assigned.";
        setErrors(temp);
        return Object.values(temp).every(x => x === "");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnLoading(true);
            try {
                const isNew = values.staffId === "00000000-0000-0000-0000-000000000000";
                const staffData = { ...values, salonId: loggedInSalonId };
                if (isNew) {
                    await axios.post(config.APIACTIVEURL + config.CREATESTAFF, staffData);
                } else {
                    await axios.put(config.APIACTIVEURL + config.UPDATESTAFF, staffData);
                }
                setShowModal(false);
                resetForm();
                GetData(pageNumber);
            } catch (error) { alert(error.response?.data?.message || "Error saving staff"); } 
            finally { setBtnLoading(false); }
        }
    };

    const handleDelete = async () => {
        if (itemToDelete) {
            try {
                await axios.delete(`${config.APIACTIVEURL}${config.DELETESTAFF}/${itemToDelete}`);
                setShowDeleteModal(false);
                GetData(pageNumber);
            } catch (error) { console.error("Delete failed", error); }
        }
    };

    const handleEdit = (staff) => {
        setValues(staff);
        setSelectedSpecializations(parseSpecializations(staff.specializations));
        setShowModal(true);
    };

    const resetForm = () => {
        setValues({ ...initialFieldValues, salonId: loggedInSalonId });
        setSelectedSpecializations([]);
        setErrors({});
    };

    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            borderColor: errors.specializations ? '#dc3545' : '#dee2e6',
            borderRadius: '0.375rem',
            boxShadow: state.isFocused ? `0 0 0 0.25rem rgba(6, 95, 70, 0.25)` : 'none',
            '&:hover': { borderColor: '#ced4da' },
            minHeight: '38px'
        }),
        multiValue: (base) => ({ ...base, backgroundColor: THEME_COLOR, color: 'white' }),
        multiValueLabel: (base) => ({ ...base, color: 'white' }),
        multiValueRemove: (base) => ({ ...base, color: 'white', ':hover': { backgroundColor: '#064e3b', color: 'white' } }),
    };

    return (
        <div className="page-content" style={{ paddingTop: "80px" }}>
            <div className="container-fluid py-3 py-md-4">
                <div className="card border-0 shadow-sm rounded-4">
                    <div className="card-header bg-white border-0 py-3 d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3">
                        <h4 className="fw-bold mb-0" style={{ color: '#064e3b' }}>Staff Master</h4>
                        <button className="btn text-white fw-bold px-4 shadow-sm"
                            style={{ backgroundColor: THEME_COLOR }}
                            onClick={() => { resetForm(); setShowModal(true); }}>
                            <i className="ri-add-line me-1"></i> Add New Staff
                        </button>
                    </div>

                    <div className="card-body p-0 p-md-3">
                        {/* DESKTOP VIEW */}
                        <div className="table-responsive d-none d-md-block">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr className="text-secondary small text-uppercase">
                                        <th className="ps-4">Staff Name</th>
                                        <th>Specializations</th>
                                        <th>Status</th>
                                        <th className="text-center pe-4">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lists.map((item) => (
                                        <tr key={item.staffId}>
                                            <td className="fw-bold text-dark ps-4">{item.name}</td>
                                            <td><div className="d-flex flex-wrap">{formatSpecializationsForDisplay(item.specializations)}</div></td>
                                            <td>
                                                <span className={`badge rounded-pill ${item.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                                                    {item.isActive ? 'Active' : 'Inactive'}
                                                </span>
                                            </td>
                                            <td className="text-center pe-4">
                                                <button className="btn btn-sm btn-outline-primary border-0 me-2" onClick={() => handleEdit(item)}><i className="ri-pencil-line fs-5"></i></button>
                                                <button className="btn btn-sm btn-outline-danger border-0" onClick={() => { setItemToDelete(item.staffId); setShowDeleteModal(true); }}><i className="ri-delete-bin-line fs-5"></i></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* MOBILE VIEW */}
                        <div className="d-md-none p-3">
                            {lists.map((item) => (
                                <div key={item.staffId} className="card border rounded-3 mb-3 shadow-sm">
                                    <div className="card-body p-3">
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <h6 className="fw-bold mb-0 text-dark">{item.name}</h6>
                                            <span className={`badge rounded-pill ${item.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                                                {item.isActive ? 'Active' : 'Inactive'}
                                            </span>
                                        </div>
                                        <div className="mb-3">
                                            <small className="text-muted d-block mb-1 fw-bold">Specializations:</small>
                                            <div className="d-flex flex-wrap">{formatSpecializationsForDisplay(item.specializations)}</div>
                                        </div>
                                        <div className="d-flex gap-2 pt-2 border-top">
                                            <Button variant="outline-primary" size="sm" className="flex-grow-1" onClick={() => handleEdit(item)}>
                                                <i className="ri-pencil-line me-1"></i> Edit
                                            </Button>
                                            <Button variant="outline-danger" size="sm" onClick={() => { setItemToDelete(item.staffId); setShowDeleteModal(true); }}>
                                                <i className="ri-delete-bin-line"></i>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* FORM MODAL */}
                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
                    <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">{values.staffId === "00000000-0000-0000-0000-000000000000" ? 'Register New Staff' : 'Edit Staff Details'}</Modal.Title></Modal.Header>
                    <Modal.Body className="px-4">
                        <form className="row g-3" onSubmit={handleSubmit}>
                            <div className="col-12"><label className="form-label small fw-bold text-muted">Staff Name *</label><input type="text" name="name" value={values.name} onChange={handleInput} className={`form-control ${errors.name ? 'is-invalid' : ''}`} placeholder="Enter staff name"/>{errors.name && <div className="invalid-feedback">{errors.name}</div>}</div>
                            <div className="col-12"><label className="form-label small fw-bold text-muted">Specializations</label><Select isMulti name="specializations" options={AVAILABLE_SPECIALIZATIONS} classNamePrefix="select" value={selectedSpecializations} onChange={handleSpecializationsChange} components={animatedComponents} styles={customSelectStyles} placeholder="Select specializations..." isSearchable={true}/></div>
                            <div className="col-md-6"><div className="form-check form-switch mt-3"><input className="form-check-input" type="checkbox" name="isActive" checked={values.isActive} onChange={handleInput} id="isActiveSwitch"/><label className="form-check-label fw-bold text-dark" htmlFor="isActiveSwitch">Active Status</label></div></div>
                            <div className="modal-footer border-0 p-0 mt-4"><button type="button" className="btn btn-light px-4 fw-bold" onClick={() => setShowModal(false)}>Cancel</button><button type="submit" disabled={btnLoading} className="btn text-white px-5 fw-bold shadow-sm" style={{ backgroundColor: THEME_COLOR }}>{btnLoading ? <Spinner size="sm" className="me-2"/> : 'Save Staff'}</button></div>
                        </form>
                    </Modal.Body>
                </Modal>

                {/* DELETE MODAL */}
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                    <Modal.Header closeButton><Modal.Title>Confirm Delete</Modal.Title></Modal.Header>
                    <Modal.Body>Are you sure you want to delete this staff member?</Modal.Body>
                    <Modal.Footer><Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button><Button variant="danger" onClick={handleDelete}>Delete Permanently</Button></Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default SalonStaff;